import React from "react";

type Variant = "primary" | "secondary" | "ghost";
type Props =
  | ({ as?: "button"; href?: never } & React.ButtonHTMLAttributes<HTMLButtonElement>)
  | ({ as: "a"; href: string } & React.AnchorHTMLAttributes<HTMLAnchorElement>);

export function Button(props: Props & { variant?: Variant }) {
  const variant = props.variant || "primary";

  const cls =
    "inline-flex items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm font-medium " +
    "focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-50 disabled:pointer-events-none " +
    (variant === "primary"
      ? "bg-primary text-primaryFg hover:opacity-95"
      : variant === "secondary"
      ? "border border-border bg-card hover:bg-bg/60"
      : "hover:bg-bg/60");

  if (props.as === "a") {
    const { as, variant: _v, ...rest } = props as any;
    return <a className={cls} {...rest} />;
  }

  const { variant: _v, ...rest } = props as any;
  return <button className={cls} {...rest} />;
}
